import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayComponent } from './overlay/overlay.component';
import { ConsoleComponent } from './console/console.component';
import { InputsComponent } from './inputs/inputs.component';
import { IndicatorComponent } from './indicator/indicator.component';



@NgModule({
  declarations: [
    OverlayComponent,
    ConsoleComponent,
    InputsComponent,
    IndicatorComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    OverlayComponent
  ]
})
export class DebugModule { }
